import { useMemo, useContext } from "react";
import { FoodCardData } from "@swiggy-private/payment-ui";
import { CardBalanceStateValue } from "@payment-client/reducers/Card";
import { CardBalanceContext } from "@payment-client/contexts/CardBalanceContext";
import { ApiFetchState } from "@swiggy-private/payment-core";
import { round } from "@payment-client/utils/Math";

function buildCardData(state: CardBalanceStateValue, paymentAmount: number): FoodCardData {
    const { balance } = state;
    const additionalBalanceRequired = balance >= paymentAmount ? 0 : round(paymentAmount - balance);

    return {
        balance,
        additionalBalanceRequired,
        isBalanceSufficent: additionalBalanceRequired === 0,
        cvvRequired: paymentAmount > 2000,
    };
}

interface CardBalanceDataProps {
    paymentAmount: number;
}

interface CardBalanceDataReturn {
    [key: string]: {
        fetchState: ApiFetchState;
        data: FoodCardData;
    };
}

export function useCardBalanceData({ paymentAmount }: CardBalanceDataProps): CardBalanceDataReturn {
    const state = useContext(CardBalanceContext);

    return useMemo(
        () =>
            Object.keys(state).reduce<CardBalanceDataReturn>((acc, cur) => {
                const _state = state[cur];
                acc[cur] = { fetchState: _state.fetchState, data: buildCardData(_state, paymentAmount) };
                return acc;
            }, {}),
        [paymentAmount, state],
    );
}
